{
  "tierProgress": {
    "tierTitle": "Your tier progress",
    "lifetimeTitle": "Your Lifetime tier progress",
    "lifetimeTarget": "Lifetime {tier}",
    "pointsToGo": "{points} tier points to go",
    "reachedLumo": "Reached",
    "tierDescription": "You're on your way to the {tier} tier",
    "lifetimeDescription": "Get {tier} benefits for life by reaching the Lifetime {tier} tier"
  }
}
